<div class="circle-selector">
    @for (option of options; track option) {
    <span
        class="circle-selector__circle-option"
        [ngClass]="{
            'circle-selector__circle-option--active':
                option.value === selectedValue
        }"
        (click)="setValue(option.value)"
    >
        {{ option.label }}
    </span>
    }
</div>
